const constants = {};
const colorSchemes = ["light", "dark"];
const MEDIA = "(prefers-color-scheme: dark)";
export {
  MEDIA,
  colorSchemes,
  constants
};
//# sourceMappingURL=constants.js.map
